// @file Network requests related to wall language detection

import type { VersionedFetchOptions } from '@@/surface/api/fetchable_object'
import FetchableObject from '@@/surface/api/fetchable_object'
import { fetchJson } from '@@/surface/api_fetch'
import type { WallDetectedLanguage, WallId } from '@@/types'
import { HTTPMethod } from '@padlet/fetch'

class WallLanguageDetectionApi extends FetchableObject {
  public static async detectLanguage(
    wallId: WallId,
    fetchOptions: VersionedFetchOptions = {},
  ): Promise<WallDetectedLanguage> {
    const { apiVersion = 1, ...otherFetchOptions } = fetchOptions
    const response = await fetchJson(`/api/${apiVersion}/walls/${wallId}/language-detection`, {
      method: HTTPMethod.get,
      ...otherFetchOptions,
    })

    return response.data.attributes as WallDetectedLanguage
  }
}

export { WallLanguageDetectionApi }
